import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const sentOrderSlice = createSlice({
  name: "sentOrder",

  initialState: {
    sentOrderData: [],
    isError1: false,
  },

  reducers: {
    fetchOrderSuccess: (state, action) => {
      state.isError1 = false;
      state.sentOrderData = action.payload;
    },
    fetchOrderFail: (state) => {
      state.isError1 = true;
    },
    resetState: (state) => {
      state.sentOrderData = [];
      state.isError1 = false;
    },
  },
});

export const { fetchOrderSuccess, fetchOrderFail, resetState } =
  sentOrderSlice.actions;

export const fetchSentOrder = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/customer/order`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });

    dispatch(fetchOrderSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchOrderFail());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default sentOrderSlice.reducer;
